module.exports = __webpack_public_path__ + "static/media/Modal_Backing_9Slice@3x.c88c8bc7.png";